import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Skills.scss';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import { useSkillsData } from '../../constants/useSkillsData';

const Skills = () => {
  // State hooks
  const [experiences, setExperiences] = useState([]);
  const skills = useSkillsData();

  // Effects hook
  useEffect(() => {
    const query = '*[_type == "experiences"]';

    client.fetch(query).then((data) => {
      setExperiences(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">
        My <span>Skills</span> & <span>Experience</span>
      </h2>
      <h3 className="subhead-text">SuperPowers</h3>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills &&
            skills.map((skill) => (
              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__skills-item app__flex"
                key={skill._id}
              >
                <div
                  className="app__flex"
                  style={{ backgroundColor: skill.bgcolor }}
                >
                  <img src={urlFor(skill.icon)} alt="skills logo" />
                </div>
                <p className="p-text text-wrap w-20 text-center">
                  {skill.name}
                </p>
              </motion.div>
            ))}
        </motion.div>
        <motion.div className="app__skills-exp">
          {experiences?.map((experience) => {
            return (
              <motion.div className="app__skills-exp-item" key={experience._id}>
                <div className="app__skills-exp-year" key={experience._id}>
                  <p className="bold-text">{experience.year}</p>
                </div>
                <motion.div className="app__skills-exp-works">
                  {experience.works.map((work) => {
                    const desc = work.desc.split('.').join('.\n\n');
                    return (
                      <>
                        <motion.div
                          whileInView={{ opacity: [0, 1] }}
                          transition={{ duration: 0.5 }}
                          className="app__skills-exp-work"
                          data-tip
                          data-for={work.name}
                          key={experience._id}
                        >
                          <h4 className="bold-text exp-title">{work.name}</h4>
                          <p className="p-text ">{work.company}</p>
                          <p className="" style={{ whiteSpace: 'pre-line' }}>
                            {desc}
                          </p>
                        </motion.div>
                      </>
                    );
                  })}
                </motion.div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__primarybg',
);
